export default "/app/themes/macleod/public/images/animated-arrow.svg?5884cadfa6bd0e72d3ed58e47dfeaa34";